<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';
import { ref, watch } from 'vue';

const { t } = useI18n();
const registerStore = useRegisterStore();

const promotionCode = ref(null);

// Sync with register store
watch(() => registerStore.register_input_fields.promotion_code, (newValue) => {
	if (newValue !== promotionCode.value) {
		promotionCode.value = newValue;
	}
}, { immediate: true });

watch(promotionCode, (newValue) => {
	registerStore.register_input_fields.promotion_code = newValue;
});

</script>

<template>
	<div class="register-form-field">
		<label>{{ $t('account.register.promotion_code') }}</label>
		<input
			@keyup="registerStore.validatePromotionCode"
			class="form-input"
			:placeholder="$t('account.register.promotion_code')"
			v-model="promotionCode"
			type="text"
			name="promotion_code"
		/>
		<div class="register-form-list" v-if="registerStore.register_errors.promotion_code && registerStore.register_errors.promotion_code.error">
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<span v-if="registerStore.register_errors.hasOwnProperty('promotion_code')">
					{{ $te('account.register.' + registerStore.register_errors.promotion_code.error) ? $t('account.register.' + registerStore.register_errors.promotion_code.error) : registerStore.register_errors.promotion_code.error }}
				</span>
			</p>
		</div>
	</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>
